export default __webpack_public_path__ + "static/media/add-credits.af17da57.png";